import {profileSeo} from '~/utils/profile-seo.mjs';
export function useProfileSeo(profile:any){
 const route=useRoute();
 const seo=computed(()=>{const person=typeof profile==='function'?profile():profile;return profileSeo({path:route.path,query:route.query,name:person?.name||person?.nickname,about:person?.about});});
 useSeoMeta({title:()=>seo.value.title,description:()=>seo.value.description,ogTitle:()=>seo.value.title,ogDescription:()=>seo.value.description,ogUrl:()=>seo.value.canonical,robots:()=>seo.value.noindex?'noindex, follow':'index, follow'});
 useHead(()=>({link:[{key:'canonical',rel:'canonical',href:seo.value.canonical}]}));
}
export function useProfileEmptySeo(empty:()=>boolean){
 const route=useRoute();
 useSeoMeta({robots:()=>profileSeo({path:route.path,query:route.query,empty:empty()}).noindex?'noindex, follow':'index, follow'});
}
